import React from 'react';
import { Capacitor } from '@capacitor/core';

const PULL_THRESHOLD = 70;

interface Props {
    pullDistance: number;
    isRefreshing: boolean;
}

export function PullToRefreshIndicator({ pullDistance, isRefreshing }: Props) {
    if (!Capacitor.isNativePlatform()) return null;
    if (pullDistance === 0 && !isRefreshing) return null;

    const progress = Math.min(pullDistance / PULL_THRESHOLD, 1);
    const ready = pullDistance >= PULL_THRESHOLD;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                display: 'flex',
                justifyContent: 'center',
                paddingTop: `${pullDistance * 0.6}px`,
                pointerEvents: 'none',
                transition: isRefreshing ? 'none' : 'padding-top 0.05s linear',
            }}
        >
            <div
                style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background: 'var(--surface, #fff)',
                    boxShadow: 'var(--shadow, 0 2px 8px rgba(0,0,0,.15))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: Math.max(progress, isRefreshing ? 1 : 0),
                    transform: `scale(${Math.max(0.5, progress)})`,
                    transition: isRefreshing ? 'none' : 'opacity 0.1s, transform 0.1s',
                }}
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={ready || isRefreshing ? 'var(--accent, #D23A3B)' : 'var(--t3, #9CA3B8)'}
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                        transform: isRefreshing ? undefined : `rotate(${progress * 360}deg)`,
                        animation: isRefreshing ? 'ptr-spin 0.8s linear infinite' : 'none',
                    }}
                >
                    <polyline points="23 4 23 10 17 10" />
                    <polyline points="1 20 1 14 7 14" />
                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
                </svg>
            </div>
            <style>{`@keyframes ptr-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        </div>
    );
}
